
import { IKeHoachMonNVActionTypes } from "../../action-types/ke-hoach/IKeHoachMonNVActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKeHoachMonNVReducer } from "../../reducer-model/ke-hoach/IKeHoachMonNVReducer";
const iniState: IKeHoachMonNVReducer = {
  filter: {
    hoc_ky: 0,
    id_bm: 0,
    id_mon: 0,
    id_chuyen_nganh: 0,
    id_he: 0,
    id_lop: 0,
    nam_hoc: "",
    khoa_hoc: 0,
    stu_nhomlop_id: 0
  },
  keHoachMons: [],
  status: eReducerStatusBase.is_loading,
  ghepLopModal: undefined
};
export const keHoachMonNVReducer = (
  state: IKeHoachMonNVReducer = iniState,
  action: IKeHoachMonNVActionTypes
): IKeHoachMonNVReducer => {
  switch (action.type) {
    case "KE_HOACH_MON_NV_CHANGE_FILTER":
      return {
        ...state,
        filter: action.payload
      }
    case "KE_HOACH_MON_NV_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading
      }
    case "KE_HOACH_MON_NV_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachMons: action.payload
      }
    case "KE_HOACH_MON_NV_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    case "KE_HOACH_MON_NV_UPDATE_KHM_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      }
    case "KE_HOACH_MON_NV_UPDATE_KHM_SUCCESS":
      const newKeHoachMons = [...state.keHoachMons];
      action.payload.forEach(e => {
        const idx = newKeHoachMons.findIndex(x => x.id_kh_mon === e.id_kh_mon)
        if (idx >= 0) {
          newKeHoachMons[idx] = {
            ...newKeHoachMons[idx],
            ...e
          }
        }
      })
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachMons: newKeHoachMons
      }
    case "KE_HOACH_MON_NV_UPDATE_KHM_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    case "KE_HOACH_MON_NV_SAVE_CHITIET_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      }
    case "KE_HOACH_MON_NV_SAVE_CHITIET_SUCCESS":
      let newKeHoachMonsAfterSave = [...state.keHoachMons];
      action.payload.forEach(item => {
        const idxKeHoachMon = newKeHoachMonsAfterSave.findIndex(x => x.id_kh_mon === item.id_kh_mon);
        if (idxKeHoachMon >= 0) {
          const keHoachMonChiTiets = [...newKeHoachMonsAfterSave[idxKeHoachMon].keHoachMonChiTiets];
          const idxKeHoachCT = keHoachMonChiTiets.findIndex(x => x.id_kh_mon_ct === item.id_kh_mon_ct);
          if (idxKeHoachCT >= 0) {
            keHoachMonChiTiets[idxKeHoachCT] = { ...item };
          } else {
            keHoachMonChiTiets.push({ ...item })
          }
          newKeHoachMonsAfterSave[idxKeHoachMon] = {
            ...newKeHoachMonsAfterSave[idxKeHoachMon],
            keHoachMonChiTiets: keHoachMonChiTiets
          }
        }
      })
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachMons: newKeHoachMonsAfterSave
      }
    case "KE_HOACH_MON_NV_SAVE_CHITIET_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    case "KE_HOACH_MON_NV_DELETE_CHITIET_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      }
    case "KE_HOACH_MON_NV_DELETE_CHITIET_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachMons: [...state.keHoachMons.map(khm => {
          return {
            ...khm,
            keHoachMonChiTiets: [...khm.keHoachMonChiTiets.filter(x => !action.payload.includes(x.id_kh_mon_ct))]
          }
        })]
      }
    case "KE_HOACH_MON_NV_DELETE_CHITIET_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    case "KE_HOACH_MON_NV_CHANGE_GHEP_LOP_MODAL":
      return {
        ...state,
        ghepLopModal: action.payload
      }
    case "KE_HOACH_MON_NV_UPDATE_GHEP_LOP_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      }
    case "KE_HOACH_MON_NV_UPDATE_GHEP_LOP_SUCCESS":
      let newKeHoachMonsAfterGhepLop = [...state.keHoachMons];
      action.payload.forEach(item => {
        const idxKeHoachMon = newKeHoachMonsAfterGhepLop.findIndex(x => x.id_kh_mon === item.id_kh_mon);
        if (idxKeHoachMon >= 0) {
          newKeHoachMonsAfterGhepLop[idxKeHoachMon].pham_vis.push(item);
        }
      })
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachMons: newKeHoachMonsAfterGhepLop,
        ghepLopModal: undefined
      }
    case "KE_HOACH_MON_NV_UPDATE_GHEP_LOP_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    default:
      return state;
  }
};
